/**
 * @generated SignedSource<<d29570340e896004bee481fb1644b44b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type HubStatus = "OFFLINE" | "ONLINE" | "%future added value";
export type SpaceCategory = "L" | "M" | "S" | "XL" | "XS" | "XXL" | "%future added value";
export type SpaceConfiguration = "BACE_CLATTERING_STANDARD" | "BACE_SATELLITE_LARGE_EXTENDED" | "BACE_SATELLITE_LARGE_STANDARD" | "BACE_SATELLITE_MEDIUM_EXTENDED" | "BACE_SATELLITE_MEDIUM_STANDARD" | "BACE_SATELLITE_SMALL_EXTENDED" | "BACE_SATELLITE_SMALL_SLIM" | "BACE_SATELLITE_SMALL_STANDARD" | "BACE_STOREFRONT_2XL" | "BACE_STOREFRONT_L" | "BACE_STOREFRONT_M" | "BACE_STOREFRONT_S" | "BACE_STOREFRONT_XL" | "BACE_TRUCK_HUB_STANDARD" | "THALIA_RENZ_STANDARD_M" | "THALIA_RENZ_STANDARD_S" | "THALIA_RENZ_STANDARD_XS" | "THALIA_RENZ_WIDE_M" | "THALIA_RENZ_WIDE_S" | "%future added value";
export type lockB2CIndexQuery$variables = {
  hubName: string;
  oneDay: any;
  oneHour: any;
  oneWeek: any;
  twoHours: any;
};
export type lockB2CIndexQuery$data = {
  readonly holdL: any;
  readonly holdM: any;
  readonly holdS: any;
  readonly holdXL: any;
  readonly holdXS: any;
  readonly holdXXL: any;
  readonly hubMeta: {
    readonly city: string;
    readonly hub: {
      readonly availableConfigurations: ReadonlyArray<{
        readonly configuration: SpaceConfiguration;
        readonly dimensions: {
          readonly depthMm: number;
          readonly heightMm: number;
          readonly widthMm: number;
        };
        readonly numSpaces: number;
        readonly spaces: ReadonlyArray<{
          readonly category: SpaceCategory;
          readonly id: string;
        }>;
      }>;
      readonly id: string;
      readonly status: HubStatus;
    };
    readonly id: string;
    readonly lat: number;
    readonly lng: number;
    readonly name: string;
    readonly postalCode: string;
    readonly street: string;
  };
  readonly oneDayEstimate: any;
  readonly oneHourEstimate: any;
  readonly oneWeekEstimate: any;
  readonly twoHoursEstimate: any;
};
export type lockB2CIndexQuery = {
  response: lockB2CIndexQuery$data;
  variables: lockB2CIndexQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubName"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "oneDay"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "oneHour"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "oneWeek"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "twoHours"
},
v5 = {
  "alias": "oneHourEstimate",
  "args": [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "until",
          "variableName": "oneHour"
        }
      ],
      "kind": "ObjectValue",
      "name": "input"
    }
  ],
  "kind": "ScalarField",
  "name": "b2CLockSessionFeeEstimate",
  "storageKey": null
},
v6 = {
  "alias": "twoHoursEstimate",
  "args": [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "until",
          "variableName": "twoHours"
        }
      ],
      "kind": "ObjectValue",
      "name": "input"
    }
  ],
  "kind": "ScalarField",
  "name": "b2CLockSessionFeeEstimate",
  "storageKey": null
},
v7 = {
  "alias": "oneDayEstimate",
  "args": [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "until",
          "variableName": "oneDay"
        }
      ],
      "kind": "ObjectValue",
      "name": "input"
    }
  ],
  "kind": "ScalarField",
  "name": "b2CLockSessionFeeEstimate",
  "storageKey": null
},
v8 = {
  "alias": "oneWeekEstimate",
  "args": [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "until",
          "variableName": "oneWeek"
        }
      ],
      "kind": "ObjectValue",
      "name": "input"
    }
  ],
  "kind": "ScalarField",
  "name": "b2CLockSessionFeeEstimate",
  "storageKey": null
},
v9 = {
  "alias": "holdXS",
  "args": [
    {
      "kind": "Literal",
      "name": "category",
      "value": "XS"
    }
  ],
  "kind": "ScalarField",
  "name": "b2CLockInitialHold",
  "storageKey": "b2CLockInitialHold(category:\"XS\")"
},
v10 = {
  "alias": "holdS",
  "args": [
    {
      "kind": "Literal",
      "name": "category",
      "value": "S"
    }
  ],
  "kind": "ScalarField",
  "name": "b2CLockInitialHold",
  "storageKey": "b2CLockInitialHold(category:\"S\")"
},
v11 = {
  "alias": "holdM",
  "args": [
    {
      "kind": "Literal",
      "name": "category",
      "value": "M"
    }
  ],
  "kind": "ScalarField",
  "name": "b2CLockInitialHold",
  "storageKey": "b2CLockInitialHold(category:\"M\")"
},
v12 = {
  "alias": "holdL",
  "args": [
    {
      "kind": "Literal",
      "name": "category",
      "value": "L"
    }
  ],
  "kind": "ScalarField",
  "name": "b2CLockInitialHold",
  "storageKey": "b2CLockInitialHold(category:\"L\")"
},
v13 = {
  "alias": "holdXL",
  "args": [
    {
      "kind": "Literal",
      "name": "category",
      "value": "XL"
    }
  ],
  "kind": "ScalarField",
  "name": "b2CLockInitialHold",
  "storageKey": "b2CLockInitialHold(category:\"XL\")"
},
v14 = {
  "alias": "holdXXL",
  "args": [
    {
      "kind": "Literal",
      "name": "category",
      "value": "XXL"
    }
  ],
  "kind": "ScalarField",
  "name": "b2CLockInitialHold",
  "storageKey": "b2CLockInitialHold(category:\"XXL\")"
},
v15 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "hubName"
      }
    ],
    "kind": "ObjectValue",
    "name": "by"
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lat",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lng",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "street",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "Hub",
  "kind": "LinkedField",
  "name": "hub",
  "plural": false,
  "selections": [
    (v16/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AvailableSpaceConfiguration",
      "kind": "LinkedField",
      "name": "availableConfigurations",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numSpaces",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "configuration",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "OutputDimensions",
          "kind": "LinkedField",
          "name": "dimensions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "widthMm",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "heightMm",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "depthMm",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Space",
          "kind": "LinkedField",
          "name": "spaces",
          "plural": true,
          "selections": [
            (v16/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "category",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Decimal"
},
v25 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "String"
},
v26 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Int"
},
v27 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "UUID"
},
v28 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Float"
},
v29 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "JSONObject"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "lockB2CIndexQuery",
    "selections": [
      (v5/*:: as any*/),
      (v6/*:: as any*/),
      (v7/*:: as any*/),
      (v8/*:: as any*/),
      (v9/*:: as any*/),
      (v10/*:: as any*/),
      (v11/*:: as any*/),
      (v12/*:: as any*/),
      (v13/*:: as any*/),
      (v14/*:: as any*/),
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v15/*:: as any*/),
          "concreteType": "HubMeta",
          "kind": "LinkedField",
          "name": "hubMeta",
          "plural": false,
          "selections": [
            (v16/*:: as any*/),
            (v17/*:: as any*/),
            (v18/*:: as any*/),
            (v19/*:: as any*/),
            (v20/*:: as any*/),
            (v21/*:: as any*/),
            (v22/*:: as any*/),
            {
              "kind": "RequiredField",
              "field": (v23/*:: as any*/),
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v2/*:: as any*/),
      (v4/*:: as any*/),
      (v1/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "lockB2CIndexQuery",
    "selections": [
      (v5/*:: as any*/),
      (v6/*:: as any*/),
      (v7/*:: as any*/),
      (v8/*:: as any*/),
      (v9/*:: as any*/),
      (v10/*:: as any*/),
      (v11/*:: as any*/),
      (v12/*:: as any*/),
      (v13/*:: as any*/),
      (v14/*:: as any*/),
      {
        "alias": null,
        "args": (v15/*:: as any*/),
        "concreteType": "HubMeta",
        "kind": "LinkedField",
        "name": "hubMeta",
        "plural": false,
        "selections": [
          (v16/*:: as any*/),
          (v17/*:: as any*/),
          (v18/*:: as any*/),
          (v19/*:: as any*/),
          (v20/*:: as any*/),
          (v21/*:: as any*/),
          (v22/*:: as any*/),
          (v23/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "222938df107605809ce6c361af62f40a",
    "id": null,
    "metadata": {
      "relayTestingSelectionTypeInfo": {
        "holdL": (v24/*:: as any*/),
        "holdM": (v24/*:: as any*/),
        "holdS": (v24/*:: as any*/),
        "holdXL": (v24/*:: as any*/),
        "holdXS": (v24/*:: as any*/),
        "holdXXL": (v24/*:: as any*/),
        "hubMeta": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "HubMeta"
        },
        "hubMeta.city": (v25/*:: as any*/),
        "hubMeta.hub": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Hub"
        },
        "hubMeta.hub.availableConfigurations": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "AvailableSpaceConfiguration"
        },
        "hubMeta.hub.availableConfigurations.configuration": {
          "enumValues": [
            "BACE_STOREFRONT_S",
            "BACE_STOREFRONT_M",
            "BACE_STOREFRONT_L",
            "BACE_STOREFRONT_XL",
            "BACE_STOREFRONT_2XL",
            "BACE_SATELLITE_SMALL_STANDARD",
            "BACE_SATELLITE_SMALL_SLIM",
            "BACE_SATELLITE_SMALL_EXTENDED",
            "BACE_SATELLITE_MEDIUM_STANDARD",
            "BACE_SATELLITE_MEDIUM_EXTENDED",
            "BACE_SATELLITE_LARGE_STANDARD",
            "BACE_SATELLITE_LARGE_EXTENDED",
            "BACE_CLATTERING_STANDARD",
            "BACE_TRUCK_HUB_STANDARD",
            "THALIA_RENZ_STANDARD_XS",
            "THALIA_RENZ_STANDARD_S",
            "THALIA_RENZ_STANDARD_M",
            "THALIA_RENZ_WIDE_S",
            "THALIA_RENZ_WIDE_M"
          ],
          "nullable": false,
          "plural": false,
          "type": "SpaceConfiguration"
        },
        "hubMeta.hub.availableConfigurations.dimensions": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "OutputDimensions"
        },
        "hubMeta.hub.availableConfigurations.dimensions.depthMm": (v26/*:: as any*/),
        "hubMeta.hub.availableConfigurations.dimensions.heightMm": (v26/*:: as any*/),
        "hubMeta.hub.availableConfigurations.dimensions.widthMm": (v26/*:: as any*/),
        "hubMeta.hub.availableConfigurations.numSpaces": (v26/*:: as any*/),
        "hubMeta.hub.availableConfigurations.spaces": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "Space"
        },
        "hubMeta.hub.availableConfigurations.spaces.category": {
          "enumValues": [
            "XS",
            "S",
            "M",
            "L",
            "XL",
            "XXL"
          ],
          "nullable": false,
          "plural": false,
          "type": "SpaceCategory"
        },
        "hubMeta.hub.availableConfigurations.spaces.id": (v27/*:: as any*/),
        "hubMeta.hub.id": (v27/*:: as any*/),
        "hubMeta.hub.status": {
          "enumValues": [
            "ONLINE",
            "OFFLINE"
          ],
          "nullable": false,
          "plural": false,
          "type": "HubStatus"
        },
        "hubMeta.id": (v27/*:: as any*/),
        "hubMeta.lat": (v28/*:: as any*/),
        "hubMeta.lng": (v28/*:: as any*/),
        "hubMeta.name": (v25/*:: as any*/),
        "hubMeta.postalCode": (v25/*:: as any*/),
        "hubMeta.street": (v25/*:: as any*/),
        "oneDayEstimate": (v29/*:: as any*/),
        "oneHourEstimate": (v29/*:: as any*/),
        "oneWeekEstimate": (v29/*:: as any*/),
        "twoHoursEstimate": (v29/*:: as any*/)
      }
    },
    "name": "lockB2CIndexQuery",
    "operationKind": "query",
    "text": "query lockB2CIndexQuery(\n  $hubName: String!\n  $oneHour: DateTime!\n  $twoHours: DateTime!\n  $oneDay: DateTime!\n  $oneWeek: DateTime!\n) {\n  oneHourEstimate: b2CLockSessionFeeEstimate(input: {until: $oneHour})\n  twoHoursEstimate: b2CLockSessionFeeEstimate(input: {until: $twoHours})\n  oneDayEstimate: b2CLockSessionFeeEstimate(input: {until: $oneDay})\n  oneWeekEstimate: b2CLockSessionFeeEstimate(input: {until: $oneWeek})\n  holdXS: b2CLockInitialHold(category: XS)\n  holdS: b2CLockInitialHold(category: S)\n  holdM: b2CLockInitialHold(category: M)\n  holdL: b2CLockInitialHold(category: L)\n  holdXL: b2CLockInitialHold(category: XL)\n  holdXXL: b2CLockInitialHold(category: XXL)\n  hubMeta(by: {name: $hubName}) {\n    id\n    name\n    lat\n    lng\n    street\n    postalCode\n    city\n    hub {\n      id\n      status\n      availableConfigurations {\n        numSpaces\n        configuration\n        dimensions {\n          widthMm\n          heightMm\n          depthMm\n        }\n        spaces {\n          id\n          category\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a538af2fda9fc0ce2271fa54ba18181f";

export default node;
